export enum actionTypes {
  PAISES_FETCH = 'PAISES_FETCH',
  PAISES_SUCCESS = 'PAISES_SUCCESS',
  PAISES_ERROR = 'PAISES_ERROR',
  PAISES_RESET = 'PAISES_RESET',
}

export enum PaisesStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface Pais {
  id: number
  nombre: string
}

export interface PaisesState {
  status: PaisesStatus
  paises: Array<Pais>
}

export interface PaisesFetch {
  type: typeof actionTypes.PAISES_FETCH
  payload: null
}

export interface PaisesSuccess {
  type: typeof actionTypes.PAISES_SUCCESS
  payload: { paises }
}

export interface PaisesError {
  type: typeof actionTypes.PAISES_ERROR
  payload: null
}

export interface PaisesReset {
  type: typeof actionTypes.PAISES_RESET
  payload: null
}

export type PaisesActions = PaisesFetch | PaisesSuccess | PaisesError | PaisesReset

export const initialState: PaisesState = {
  status: PaisesStatus.Idle,
  paises: [],
}
